//api/index.js

import axios from "axios";

const prefix = "/api";
const SERVER_URL = process.env.REACT_APP_API_ENDPOINT;
let tokens = localStorage.getItem("token");

const jwtInterceoptor = axios.create({});

jwtInterceoptor.interceptors.request.use(async (config) => {

  console.log("tokens", tokens);
  if (tokens) {
    // const headers = new Map();
    // headers.set('Authorization', `Bearer ${tokens}`);
    // // { Authorization: "Bearer " + user.accessToken };
    // config.headers = headers;
    config.headers.set("Authorization", `bearer ${tokens}`);

  }
  return config;
});

jwtInterceoptor.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log("error", error);
    try {
      if (error.response.status === 401) {
        const tokens = localStorage.getItem("token");

        if (tokens && tokens.accessToken && tokens.refreshToken) {
          const payload = {
            accessToken: tokens.accessToken,
            refreshToken: tokens.refreshToken,
          };
          let apiResponse = await axios.post(
            `${SERVER_URL}/api/auth/refreshtoken`,
            payload
          );
          localStorage.setItem("token", apiResponse.data.tokens);
          error.config.headers.set(
            "Authorization",
            `Bearer ${apiResponse.data.tokens.accessToken}`
          );
        }
        return axios(error.config);
      } else {
        // await storage.removeItem("tokens");
        return Promise.reject(error);
      }
    } catch (e) {
      // consol
      if (error.response.status == 401)
        console.error("error", e);
    }
  }
);

const login = (data) => {
  return axios.post(`${SERVER_URL}/auth/signin`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getTicketCounts = async (index) => {
 // return await axios.get(`${SERVER_URL}/tickets_count`, {
     return await axios.get(`${SERVER_URL}/tickets_count?provider=${index}`, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const getStasticsReport = async (data) => {
  return await axios.post(`${SERVER_URL}/statistics_report`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getCompleteReport = async (data) => {
  return await axios.post(`${SERVER_URL}/complete_report`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getReportHrc = async (data) => {
  return await axios.post(`${SERVER_URL}/report_hfc`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getReportGpon = async (data) => {
  return await axios.post(`${SERVER_URL}/report_gpon`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getReportCopper = async (data) => {
  return await axios.post(`${SERVER_URL}/report_copper`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getTickets = async (data) => {
  return await axios.post(`${SERVER_URL}/get_ticket`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getFilterTickets = async (data) => {
  return await axios.post(`${SERVER_URL}/ticket_filter`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getTicket = async (index) => {
  return await axios.get(`${SERVER_URL}/ticket/${index}`, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const createUser = async (data) => {
  return await axios.post(`${SERVER_URL}/users`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const getUsers = async () => {
  return await axios.get(`${SERVER_URL}/users`, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const getUser = async (id) => {
  return await axios.get(`${SERVER_URL}/users/${id}`, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const getUserTickets = async (data) => {
  return await axios.post(`${SERVER_URL}/user_ticket`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const updateUser = async (id, data) => {
  return await axios.put(`${SERVER_URL}/users/${id}`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const deleteUser = async (id) => {
  return await axios.delete(`${SERVER_URL}/users/${id}`, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const changePassword = async (data) => {
  return await axios.post(`${SERVER_URL}/change_password`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const updateTicketTechnician = async (id, data) => {
  return await axios.put(`${SERVER_URL}/update_technician/${id}`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const updateTicketStatus = async (id, data) => {
  return await axios.put(`${SERVER_URL}/update_status/${id}`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const createTicket = async (data) => {
  return await axios.post(`${SERVER_URL}/ticket`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
      "Content-Type": "multipart/form-data",
    }
  });
};

const updateTicket = async (id, data) => {
  return await axios.post(`${SERVER_URL}/ticket/${id}?_method=PUT`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
      "Content-Type": "multipart/form-data",
    }
  });
};

const updateTicketMaterial = async (id, data) => {
  return await axios.put(`${SERVER_URL}/material/${id}`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const closeTicket = async (id) => {
  return await axios.put(`${SERVER_URL}/close_ticket/${id}`, {}, {
    headers: {
      'Authorization': `Bearer ${tokens}`
    }
  });
};

const createTicketComment = async (data) => {
  return await axios.post(`${SERVER_URL}/comments`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const deleteTicketComment = async (id) => {
  return await axios.delete(`${SERVER_URL}/comments/${id}`, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getDailyReport = async (data) => {
  return await axios.post(`${SERVER_URL}/daily_report`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getReportTechnician = async (data) => {
  return await axios.post(`${SERVER_URL}/technician_report`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getReportStatus = async (data) => {
  return await axios.post(`${SERVER_URL}/status_report`, data, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};


const getRoles = async () => {
  return await axios.get(`${SERVER_URL}/roles`, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

const getCompany = async () => {
  return await axios.get(`${SERVER_URL}/company`, {
    headers: {
      'Authorization': `Bearer ${tokens}`,
    }
  });
};

export const api = {
  login,
  getTicketCounts,
  getStasticsReport,
  getCompleteReport,
  getReportHrc,
  getReportGpon,
  getReportCopper,
  getTickets,
  getFilterTickets,
  getTicket,
  createUser,
  getUsers,
  getUser,
  getUserTickets,
  updateUser,
  deleteUser,
  changePassword,
  updateTicketTechnician,
  updateTicketStatus,
  createTicket,
  updateTicket,
  updateTicketMaterial,
  closeTicket,
  createTicketComment,
  deleteTicketComment,
  getDailyReport,
  getReportTechnician,
  getReportStatus,
  getRoles,
  getCompany
};
